import { Link as ChakraLink } from '@chakra-ui/react';
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import type { Route } from 'next';
import NextLink from 'next/link';
import type { PropsWithChildren } from 'react';

type LinkProps<T extends string> = {
	href:      Route<T>
	isNewTab?: boolean
} & Omit<ChakraLinkProps, 'as' | 'href'>;

export const NextLinkWrapper = <T extends string>({
	children,
	href,
	isNewTab = false,
	...props
}: PropsWithChildren<LinkProps<T>>) => {
	const openInNewTab = {
		rel:    'noopener noreferrer',
		target: '_blank',
	};

	return (
		<ChakraLink asChild textDecoration="none" {...props}>
			<NextLink href={href} {...(isNewTab ? openInNewTab : {})}>
				{children}
			</NextLink>
		</ChakraLink>
	);
};
